package com.example.mystybag.communication.ext

import com.example.mystybag.sharedmodels.base.BaseResponseModel

sealed class CommandResult<SuccessModel, ErrorModel> {
    data class Success<SuccessModel: BaseResponseModel> (val successModel: SuccessModel)                    : CommandResult<SuccessModel, Unit>()
    data class Error<ErrorModel: BaseResponseModel>     (val errorModel: ErrorModel)                        : CommandResult<Unit, ErrorModel>()
    data class BaseError<BaseError>                     (val baseErrorModel: BaseResponseModel)             : CommandResult<Unit, BaseError>()

    fun process(success: (SuccessModel) -> Unit, error: ((ErrorModel) -> Unit)? = null, baseError: ((BaseResponseModel) -> Unit)? = null) {
        when (this) {
            is Success    -> success.invoke(successModel)
            is Error      -> error?.invoke(errorModel)
            is BaseError  -> baseError?.invoke(baseErrorModel)
        }
    }
}